import type { RoomChatEntry } from "@golazo/shared";
import { t } from "../i18n/index.js";
import { tierMarkNode } from "./tierMark.js";

/**
 * La frase de un aviso del sistema del chat.
 *
 * El servidor manda un CODIGO ("joined") y no la frase: no sabe en que idioma
 * juega cada uno. Aqui se pone con `t()`, igual en la sala y en el partido.
 */
export function chatEventText(entry: RoomChatEntry): string {
  const nick = entry.nickname;
  switch (entry.event) {
    case "joined":
      return t("{nick} ha entrado en la sala", { nick });
    case "left":
      return t("{nick} se ha ido", { nick });
    case "kicked":
      return t("{nick} ha sido expulsado", { nick });
    case "host":
      return t("{nick} es el nuevo anfitrión", { nick });
    case "benched":
      return t("{nick} pasa al banquillo", { nick });
    case "seated":
      return t("{nick} entra al partido", { nick });
    case "stopped":
      return t("{nick} ha parado el partido", { nick });
    default:
      return "";
  }
}

/**
 * Una linea del chat como nodo del DOM, nunca como HTML.
 *
 * El texto y el apodo los escribe OTRA persona: pasarlos por `innerHTML` seria
 * dejar que cualquiera de la sala ejecutara codigo en el navegador de los
 * demas. Todo va por `textContent`.
 */
export function chatLineNode(entry: RoomChatEntry, selfId: string, tag: "li" | "p" = "li"): HTMLElement {
  const line = document.createElement(tag);
  if (entry.event) {
    line.className = "chat-line is-system";
    line.textContent = chatEventText(entry);
    return line;
  }
  line.className = `chat-line${entry.from === selfId ? " is-me" : ""}`;
  const who = document.createElement("b");
  who.className = "chat-nick";
  who.textContent = entry.nickname;
  const mark = tierMarkNode(entry.tier);
  if (mark) who.prepend(mark);
  const text = document.createElement("span");
  text.className = "chat-text";
  text.textContent = entry.text ?? "";
  line.append(who, text);
  return line;
}
